<script>
import { Line } from 'vue-chartjs'

export default {
  extends: Line,
  props: ['options','height','width','data'],
  methods: {
    newData: function() {
      this.renderChart({
        labels: this.labels,
        datasets: [
          {
            data: this.activite,
            fill: false,
            yAxisID: 'A',
            borderColor: "rgba(123,111,255, 0.6)", // <-- supposed to be light blue
            // borderColor: "#41c6ff",
            label: "Sauvegardes"
          },
          {
            data: this.usagers,
            fill: false,
            yAxisID: 'B',
            // backgroundColor: "rgba(255,152,111, 0.3)",
            borderColor: "rgba(255,152,111,0.6)",
            label: "Connexions"
          },
        ]},
        {
          title: {
            display: true,
            fontSize: 20,
            text: 'Activité du jour'
          },
          // responsive: false,
          // Can't just just `stacked: true` like the docs say
          scales: {
            // xAxes: [{ stacked: true }],
            yAxes: [{
              id: 'A',
              // type: 'logarithmic',
              position: 'left',
              gridLines: {
                color: "rgba(123,111,255, 0.3)",
              },
              scaleLabel: {
                display: true,
                labelString: 'Sauvegardes'
              },
              ticks: {min: 0, suggestedMax: 20 },
              // stacked: true,
            }, {
              id: 'B',
              position: 'right',
              gridLines: {
                color: "rgba(255,152,111,0.3)",
              },
              scaleLabel: {
                display: true,
                labelString: 'Usagers'
              },
              ticks: { min: 0, suggestedMax: 20 },
            }],
          },
          animation: {
            duration: 750,
          },
        }
      )
    }
  },
  computed: {
    labels: function() {
      let result = [];
      for (const [key] of Object.entries(this.data)) {
        result.push(key);
      }
      return result;
    },
    // datasets
    activite: function() {
      let result = [];
      for (const [,value] of Object.entries(this.data)) {
        result.push(value.saves);
      }
      return result;
    },
    usagers: function() {
      let result = [];
      for (const [,value] of Object.entries(this.data)) {
        result.push(value.activeUsers);
      }
      return result;
    }
  },
  watch: {
    data: function() {
      this.newData();
    }
  },
  mounted() {
    this.newData();
  }
}
</script>
